import type { SitrepSectionType } from 'components/DisasterGPT/hooks/useSitrepsV2';

type SectionVersion = SitrepSectionType['section_versions'][number];

export const isPendingAiReviewStatus = (status: string | undefined): boolean =>
  (status || '').toLowerCase() === 'pendingreview';

export const sitrepSectionDisplay = (
  section: Pick<SitrepSectionType, 'section_versions'>
): { display?: SectionVersion; pending?: SectionVersion } => {
  const versions = section.section_versions ?? [];
  const latest = versions[0];
  if (latest && isPendingAiReviewStatus(latest.status)) {
    return { display: versions[1], pending: latest };
  }
  return { display: latest, pending: undefined };
};

export const isSitrepSectionGenerating = (
  section: Pick<SitrepSectionType, 'section_versions'>
): boolean => {
  const status = (section.section_versions?.[0]?.status || '').toLowerCase();
  if (!status) return false;
  return !['completed', 'summarized', 'error', 'pendingreview'].includes(status);
};
